import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import { SetActiveArtist, UpdateAchievement } from '../action-creators';
import AppState from '../../state';
import { NoOp } from '@webapp/store/ui/action-creators';
import { SET_ACTIVE_ARTIST } from '../actions';
import { Actions } from '../../actions';

export const updateArtistFirstLoginEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, SetActiveArtist>(SET_ACTIVE_ARTIST),
    withLatestFrom(state$),
    map(([_, state]) => {
      if (state.artist.active) {
        let id = state.artist.achievements.find(
          (val) => val.achievementKey === 'first-login'
        )?.id;
        if (!state.artist.active.achievements?.includes(id || '')) {
          if (id) {
            return new UpdateAchievement(state.artist.active.id, id as string);
          }
        }
        return new NoOp();
      }
      return new NoOp();
    })
  );
